const namespace = 'workflows.first_review.';

const translations = {
    completeReview: `${namespace}complete_review`,
    handBack: `${namespace}hand_back`,
    underReview: `${namespace}under_review`,
};

export { translations };
